import { render } from "./empty-all-reviewed-message.vue?vue&type=template&id=60d61dce&ts=true"
import script from "./empty-all-reviewed-message.ts?vue&type=script&lang=ts&external"
export * from "./empty-all-reviewed-message.ts?vue&type=script&lang=ts&external"

import "./empty-all-reviewed-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__